import React from "react";

import BaseChart from "./BaseChart";
import { COLORS } from "Constants";

export enum AxisType {
  LINEAR = "linear",
  LOGARITHMIC = "logarithmic",
  DATE_TIME = "datetime",
  CATEGORY = "category"
}

interface LineChartProps {
  categories?: any[];
  colors: string[];
  height?: number;
  legendItemClickable?: boolean;
  series: Highcharts.SeriesSplineOptions[];
  title?: string;
  xAxisType?: AxisType;
  xMax?: number;
  xMin?: number;
  yAxisType?: AxisType;
  yMax?: number;
  yMin?: number;
  yLabel?: string;
}

const LineChart: React.FC<LineChartProps> = props => {
  const {
    categories,
    colors,
    height,
    legendItemClickable = false,
    series,
    title,
    xMax,
    xMin,
    xAxisType = AxisType.LINEAR,
    yAxisType = AxisType.LINEAR,
    yLabel,
    yMax,
    yMin
  } = props;

  return (
    <BaseChart
      colors={colors}
      options={{
        chart: {
          type: "spline",
          height: height
        },
        title: {
          text: title || "",
          align: "left",
          style: {
            color: COLORS.WHITE
          }
        },
        series: series,
        xAxis: {
          softMin: xMin,
          softMax: xMax,
          categories: categories,
          type: xAxisType
        },
        yAxis: {
          softMin: yMin,
          softMax: yMax,
          title: {
            text: yLabel
          },
          type: yAxisType
        },
        legend: {
          itemStyle: {
            color: COLORS.WHITE,
            cursor: "default"
          },
          itemHoverStyle: {
            color: COLORS.WHITE
          }
        }
      }}
      plotOptions={{
        series: {
          events: {
            legendItemClick: function() {
              return legendItemClickable;
            }
          }
        }
      }}
    />
  );
};

export default LineChart;
